import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hress3u/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hress3u/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtest: (typeof searchParams.dteapprst !== 'undefined' ? searchParams.dteapprst : ''),
        p_dteen: (typeof searchParams.dteappren !== 'undefined' ? searchParams.dteappren : ''),
        p_staappr: (typeof searchParams.staappr !== 'undefined' ? searchParams.staappr : 'P'),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    return instance().get(endpoint + '/hress3u/index', { params: sendParams })
  },
  getDetail (detailParams) {
    let searchParams = {
      p_codempid: detailParams.codempid,
      p_dtereq: detailParams.dtereq.replace(/\//g, ''),
      p_numseq: detailParams.numseq
    }
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq
    return instance().get(endpoint + '/hress3u/detail/' + params)
  },
  getDetailSubmit (detailParams) {
    let searchParams = {
      p_codempid: detailParams.codempid,
      p_dtereq: detailParams.dtereq.replace(/\//g, ''),
      p_numseq: detailParams.numseq,
      p_approvno: detailParams.approvno,
      p_staappr: detailParams.staappr
    }
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq + '/' + searchParams.p_approvno + '/' + searchParams.p_staappr
    if (isMock) return generator(mocker.detailSubmit())
    return instance().get(endpoint + '/hress3u/detailSubmit/' + params)
  },
  postSendApprove (approveParams) {
    let paramJson = {
      '0': {
        p_staappr: approveParams.flgStaappr,
        p_approvno: approveParams.approvno,
        p_chk_appr: approveParams.chk_appr,
        p_numseq: approveParams.numseq,
        p_codempid: approveParams.codempid,
        p_dtereq: approveParams.dtereq.replace(/\//g, ''),
        p_dteappr: approveParams.dteappr.replace(/\//g, ''),
        p_dteeffec: approveParams.dteeffec.replace(/\//g, ''),
        p_remark: approveParams.remark,
        p_flgwarn: ''
      }
    }
    let sendParams = {
      param_json: JSON.stringify(paramJson),
      remarkApprove: (approveParams.flgStaappr === 'A') ? approveParams.remark : '',
      remarkReject: (approveParams.flgStaappr === 'N') ? approveParams.remark : ''
    }
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hress3u/sendApprove', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hress3u/index.js